<template>
    <!-- <Breadcrumbs main="Setting" mains="Destination Management" title="Destination Management" /> -->
    <div class="container-fluid default-dashboard">
        <div class="card">
            <div class="card-header">
                <div class="d-flex justify-content-between align-items-center">
                    <h5>Destination List</h5>
                </div>
            </div>
            <div class="card-body">
                <DataTable
                    :headers="headers"
                    :items="destinations"
                    :loading="loading"
                    :total="total"
                    :params="params"
                >
                </DataTable>
            </div>
        </div>
    </div>
</template>

<script lang="ts" setup>
import { ref, reactive, onMounted } from 'vue'
import { toast } from 'vue3-toastify'
import 'vue3-toastify/dist/index.css'
import DataTable from '@/components/table/Datatable.vue'
import { Modal } from 'bootstrap'

// {{ Define Destination interface }}
interface Destination {
    ID: number | null; // Allow null for new destinations
    province: string;
}

const headers = [
    { text: 'Province', value: 'province' },
]

// {{ Apply types to refs and reactive objects }}
const destinations = ref<Destination[]>([])
const loading = ref(false)
const total = ref(0)
const params = reactive<DataTableParams>({
    page: 1,
    size: 10,
    search: ''
})
// Add this data data array
const dataDestinations: Destination[] = [ // Apply Destination type
    { ID: 1, province: 'ADMIN'},
]

const fetchDestinations = async () => {
    loading.value = true
    try {
        // Simulate API delay
        await new Promise(resolve => setTimeout(resolve, 500))

        // Filter based on search
        let filteredDestinations = [...dataDestinations]
        if (params.search) {
            const searchLower = params.search.toLowerCase()
            filteredDestinations = dataDestinations.filter(destination =>
                destination.province.toLowerCase().includes(searchLower))
        }

        // Calculate pagination
        const start = (params.page - 1) * params.size
        const end = start + params.size
        destinations.value = filteredDestinations.slice(start, end)
        total.value = filteredDestinations.length

    } catch (error) {
        toast.error('Failed to fetch destinations')
    }
    loading.value = false
}
onMounted(() => {
    fetchDestinations() // Fetch destinations on mount
})

// Initial fetch is now called in onMounted
</script>